export default "__VITE_ASSET__BX4fsc3I__"